module.exports = __webpack_public_path__ + "img/cloud-minus.4070fad9.svg";